import React from "react";
import { useSelector } from "react-redux";
import { isLoaded, isEmpty } from "react-redux-firebase";
import SignedInLinks from "./SignedInLinks";
import SignedOutLinks from "./SignedOutLinks";

import "./Navbar.scss";
import { Link } from "react-router-dom";

import { HOME_PATH } from "../../constants/paths";

function Navbar() {
  // Get auth from redux state
  const auth = useSelector(({ firebase }) => firebase.auth);
  const authExists = isLoaded(auth) && !isEmpty(auth);
  const profile = useSelector(({ firebase }) => firebase.profile);
  const profileExists = isLoaded(profile) && !isEmpty(profile);

  return (
    <nav className="flex items-center justify-between px-16 py-3 shadow-md border-t-4 border-brand-700">
      <Link
        className="flex items-center flex-shrink-0 text-white mr-6"
        to={HOME_PATH}
      >
        <span className="font-bold text-brand-700 text-xl tracking-tight">
          El Señorón
        </span>
      </Link>
      {authExists ? <SignedInLinks /> : <SignedOutLinks />}
    </nav>
  );
}

export default Navbar;
